import { GEOLOCATION_STATUS, GEOLOCATION_POSITION, CANDC_STORE_DETAILS, CHANGE_OTHER_METHODS, CHANGE_OTHER_STORE } from '../actionTypes/index';

const initialState = {
	allowed: undefined,
	latitude: null,
	longitude: null,
	storeDetails: undefined,
	changeStore: undefined,
	changeMethods: undefined
}

const geoLocationReducer = (state = initialState, action) => {
    switch (action && action.type) {
			case GEOLOCATION_STATUS:
				return {
					...state,
					allowed: action.payload
				}
			case GEOLOCATION_POSITION:
				return {
					...state,
					latitude: action.payload.latitude,
					longitude: action.payload.longitude
				}
			case CANDC_STORE_DETAILS:
				return {
					...state,
					storeDetails: action.payload
				}
			case CHANGE_OTHER_STORE:
				return {
					...state,
					changeStore: action.payload
				}
			case CHANGE_OTHER_METHODS:
				return {
					...state,
					changeMethods: action.payload
				}
			default:
				return state;
    }
}

export default geoLocationReducer;